import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  display: flex;
  cursor: pointer;
  padding: ${rem(10)} ${rem(18)};
  background: ${({ theme }) => theme.color.white};
  gap: ${rem(14)};
  ${({ theme }) => theme.media.fold`
    padding: ${rem(8)} ${rem(20)};
    gap: ${rem(12)};
  `}
`;

export const TextArea = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: ${rem(8)};
  padding-bottom: ${rem(16)};
  border-bottom: ${({ theme }) => `1px solid ${theme.color['gray-200']}`};
  ${({ theme }) => theme.media.fold`
    gap: ${rem(6)};
  `}
`;

export const TextTopArea = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Title = styled.div`
  display: flex;
  gap: ${rem(2)};
  flex-direction: column;
  ${({ theme }) => theme.media.fold`
    gap: ${rem(2)};
  `}
`;

export const TextMiddleArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${rem(2)};
`;

export const Label = styled.div`
  display: flex;
  gap: ${rem(4)};
  align-items: flex-start;
  margin-right: ${rem(14)};
  &:last-child {
    margin-right: 0;
  }
`;

export const LabelWrapper = styled.div`
  padding: ${rem(3)} 0;
  ${({ theme }) => theme.media.fold`
    padding: ${rem(2)} 0;
  `}
`;
